import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useGetPosMonthsKpiRequest, useUpdatePosMonthKPIRequest, usePosMonthRequest } from "../../hooks/useApi";
import BackIcon from '../../components/Icons/BackIcon';
import { NumericFormat } from 'react-number-format';
import { creatMonthlyKpiState, CURRENCY_MAP, deepMerge, MONTH_MAP, currencyToNumber } from '../../utils/helpers';
import PlanStatus from '../../components/PlanStatus';
import debounce from 'lodash.debounce';
import TextInput from '../../components/TextInput';
import { FormatMoney } from '../../utils/number-formats';
import './index.css';

const MonthlyTargetSales = (props) => {
  const posId = localStorage.getItem('posId');
  const posDs = localStorage.getItem('posDs');
  const yearNumber = localStorage.getItem('selectedYear');
  const monthNumber = localStorage.getItem('month');

  const [targetData, setTargetData] = useState(null);
  const [storeData, setStoreData] = useState(null);
  const [ s1, executeRequest ] = useGetPosMonthsKpiRequest();
  const [ s2, updatePosMonthKpi ] = useUpdatePosMonthKPIRequest();
  const [ {}, getStoreData ] = usePosMonthRequest();
  const [formData, setFormData] = useState([]);

  const handleChange = async(event) => {
    const { target: { value, name } } = event;
    const fieldName = event.target.getAttribute('data-prop');
    const newObj = {
      [name]: {
        [fieldName]: currencyToNumber(value)
      }
    };
    const mergedObj = deepMerge(formData, newObj);
    setFormData(mergedObj);
    debouncedSave.cancel();
    debouncedSave(event, mergedObj);
  };

  const debouncedSave = useCallback(
    debounce(async(event, obj) => {
      const { target: { value, name } } = event;
      const bodyParams = { posId, month: monthNumber, year: yearNumber, upt: obj[posId]?.uptTarget, averagePrice: obj[posId]?.averagePriceTarget, numberOfReceipt: obj[posId]?.numberOfReceiptTarget};
      await updatePosMonthKpi({ bodyParams });
      await FetchMonthKpi();
    }, 1000),
    [], // will be created only once initially
  );

  const FetchMonthKpi = useCallback(async () => {
    if (posId && monthNumber && yearNumber)
      {
        const bodyParams = {
          posIds: [posId],
          month: monthNumber,
          year: yearNumber
        };

        const response = await executeRequest({ bodyParams });
        setTargetData(response?.data);
        setFormData(creatMonthlyKpiState(response?.data));

        const storeBodyParams = {
          posId: posId,
          month: monthNumber,
          year: yearNumber
        };
        const storeResponse = await getStoreData({ bodyParams: storeBodyParams });
        setStoreData(storeResponse?.data);
      }
  }, [posId, monthNumber, yearNumber])

  useEffect(() => {
    FetchMonthKpi();
  }, [posId, monthNumber, yearNumber]);

  const handleGoBackClick = () => {
    const backUrl = localStorage.getItem('backUrl');
    window.location.replace(backUrl);
  }


  // if (loadingDaysUpdate)
  //   return <LoadingOverlay />
  const budget = storeData?.budget;
  const plannedBudget = storeData?.planned;
  const remaining = plannedBudget - budget;
  const currency = CURRENCY_MAP[storeData?.currency] ? CURRENCY_MAP[storeData?.currency] : storeData?.currency;
  return (
    <div className="monthlyKpiPage">
      <div className="etroContainer titleWrapper dFlex">
        <div className="dFlex justifyContentStart alignItemsCenter gap-1 left">
          <Link to={`/projects/`} ><BackIcon /></Link>
          <h1>{posDs} Planned Sales / {MONTH_MAP[monthNumber]} {yearNumber}</h1>
        </div>
        <div className="center">KPI</div>
        <div className="right">
          {/* <OutlinedBtn title="View Turnover per SA" variant="outlined" onClick={handleTurnoverSaClick} to="/sa-kpi" >View Turnover per SA</OutlinedBtn> */}
        </div>
      </div>
        <>
          <div className="tableWrapper">
            <div className="budgetWrapper gap-3">
              <div className="budgetItem">
                <div className="title">Budget:</div>
                <div className="value">{<NumericFormat value={budget} thousandSeparator=" " prefix={`${currency} `} displayType="text" decimalScale={0} />}</div> 
              </div>
              <div className="budgetItem dFlex justifyContentSpaceBetween">
                <div>
                  <div className="title">Planned:</div> 
                  <div className="value">{<NumericFormat value={plannedBudget} thousandSeparator=" " prefix={`${currency} `} displayType="text" decimalScale={0} />}</div> 
                </div>
                <PlanStatus value={remaining} />
              </div>
              <div className="budgetItem">
                <div className="title">Remaining:</div> 
                <div className="value">{<NumericFormat className={remaining < 0 ? 'underTarget' : ''} value={remaining} thousandSeparator=" " prefix={`${currency} `} displayType="text" decimalScale={0} />}</div> 
              </div>
            </div>
          </div>
          <div className="monthlyKpiTableWrapper">
          { targetData && (
            <table className="monthlyKpiTable" style={{ width: "100%", marginTop: '32px' }}>
              <thead>
                <tr className="bgTableGrey">
                  <th colSpan="4">Budget</th>
                  <th colSpan="4">Average Price</th>
                  <th colSpan="4">UPT</th>
                  <th colSpan="4"># Transaction</th>
                  <th colSpan="4">ATV</th>
                </tr>
                <tr className="bgTableGrey textCenter splitCols">
                  <th className="borderRightNone pl0 pr0 textCenter">Target</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Actual</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Δ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  <th className="borderLeftNone pl0 pr0 textCenter">Δ% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  
                  <th className="borderRightNone pl0 pr0 textCenter">Target</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Actual</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Δ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  <th className="borderLeftNone pl0 pr0 textCenter">Δ% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  
                  <th className="borderRightNone pl0 pr0 textCenter">Target</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Actual</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Δ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  <th className="borderLeftNone pl0 pr0 textCenter">Δ% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  
                  <th className="borderRightNone pl0 pr0 textCenter">Target</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Actual</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Δ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  <th className="borderLeftNone pl0 pr0 textCenter">Δ% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>

                  <th className="borderRightNone pl0 pr0 textCenter">Target</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Actual</th>
                  <th className="borderRightNone borderLeftNone pl0 pr0 textCenter">Δ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  <th className="borderLeftNone pl0 pr0 textCenter">Δ% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                  
                </tr>
              </thead>
              <tbody>
                {
                  targetData.map(({ posId, averagePriceActual, averagePriceDelta, averagePriceDeltaPercentage, budgetTarget, budgetActual, budgetDelta, budgetDeltaPercentage, numberOfReceiptDeltaPercentage, numberOfReceiptActual, numberOfReceiptDelta, uptActual, uptDelta, uptDeltaPercentage, vptTarget, vptActual, vptDelta, vptDeltaPercentage }) => {
                    return (
                      <tr className="" key={posId}>
                        <td className="borderRightNone textCenter planned">{<FormatMoney value={budgetTarget || 0} prefix={currency} />}</td>
                        <td className="borderRightNone textCenter planned">{<FormatMoney value={budgetActual || 0} prefix={currency} />}</td>
                        <td className="borderRightNone textCenter planned"><span className={budgetDelta > 0 ? 'textGreen' : 'textYellow'}>{<FormatMoney value={budgetDelta || 0} prefix={currency} />}</span></td>
                        <td className="textCenter planned"><span className={budgetDelta > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={budgetDeltaPercentage || 0} suffix=" %" thousandSeparator=" " displayType="text" decimalScale={2} />}</span></td>
                        
                        <td className={"borderRightNone leftPadding avgPriceTarget"}>
                          <FormatMoney
                            value={formData[posId]['averagePriceTarget']}
                            prefix={currency}
                            decimalScale={2}
                            renderText={(value) =>
                              <TextInput
                                value={value}
                                name={posId}
                                onChange={handleChange}
                                dataProp={"averagePriceTarget"}
                              />
                            }
                          />
                        </td>
                        <td className="borderRightNone textCenter planned">{<FormatMoney decimalScale={2} value={averagePriceActual || 0} prefix={currency} />}</td>
                        <td className="borderRightNone textCenter planned"><span className={averagePriceDelta > 0 ? 'textGreen' : 'textYellow'}>{<FormatMoney decimalScale={2} value={averagePriceDelta || 0} prefix={currency} />}</span></td>
                        <td className="textCenter planned"><span className={averagePriceDeltaPercentage > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={averagePriceDeltaPercentage || 0} suffix=" %" thousandSeparator=" " displayType="text" decimalScale={2} />}</span></td>

                        <td className={"borderRightNone leftPadding target"}>
                          <FormatMoney
                            value={formData[posId]['uptTarget']}
                            prefix={""}
                            decimalScale={2}
                            renderText={(value) =>
                              <TextInput
                                value={value}
                                name={posId}
                                onChange={handleChange}
                                dataProp={"uptTarget"}
                              />
                            }
                          />
                        </td>
                        <td className="borderRightNone textCenter planned">{<NumericFormat value={uptActual || 0} thousandSeparator=" " displayType="text" decimalScale={2} />}</td>
                        <td className="borderRightNone textCenter planned"><span className={uptDelta > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={uptDelta || 0} thousandSeparator=" " displayType="text" decimalScale={2} />}</span></td>
                        <td className="textCenter planned"><span className={uptDeltaPercentage > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={uptDeltaPercentage || 0} suffix=" %" thousandSeparator=" " displayType="text" decimalScale={2} />}</span></td>

                        <td className={"borderRightNone leftPadding target"}>
                          <FormatMoney
                            value={formData[posId]['numberOfReceiptTarget']}
                            prefix={""}
                            renderText={(value) =>
                              <TextInput
                                value={value}
                                name={posId}
                                onChange={handleChange}
                                dataProp={"numberOfReceiptTarget"}
                              />
                            }
                          />
                        </td>
                        <td className="borderRightNone textCenter planned">{<NumericFormat value={numberOfReceiptActual || 0} thousandSeparator=" " displayType="text" decimalScale={0} />}</td>
                        <td className="borderRightNone textCenter planned">
                          <span className={numberOfReceiptDelta > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={numberOfReceiptDelta || 0} thousandSeparator=" " displayType="text" decimalScale={0} />}</span>
                        </td>
                        <td className="textCenter planned">
                          <span className={numberOfReceiptDeltaPercentage > 0 ? 'textGreen' : 'textYellow'}>
                            {<NumericFormat value={numberOfReceiptDeltaPercentage || 0} suffix=" %" thousandSeparator=" " displayType="text" decimalScale={0} />}
                          </span>
                        </td>
                        
                        <td className="borderRightNone textCenter planned">{<NumericFormat value={vptTarget || 0} thousandSeparator=" " displayType="text" decimalScale={2} />}</td>
                        <td className="borderRightNone textCenter planned">{<NumericFormat value={vptActual || 0} thousandSeparator=" " displayType="text" decimalScale={2} />}</td>
                        <td className="borderRightNone textCenter planned">
                          <span className={vptDelta > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={vptDelta || 0} thousandSeparator=" " displayType="text" decimalScale={2} />}</span>
                        </td>
                        <td className="textCenter planned">
                          <span className={vptDeltaPercentage > 0 ? 'textGreen' : 'textYellow'}>{<NumericFormat value={vptDeltaPercentage || 0} suffix=" %" thousandSeparator=" " displayType="text" decimalScale={2} />}</span>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
            )}
            { (!targetData || targetData.length <= 0) && (
              <h2 className="mt-4 text-center fs-32 font-bold">No KPIs found</h2>
            )}
          </div>
          <br/><br/><br/><br/>
        </>
    </div>  
  );
};

export default MonthlyTargetSales;
